import { useState, useEffect } from "react";

//creamos la interfaz
interface WindowsSize {
  width: number;
  height: number;
}

const useWindowsSize = (): WindowsSize => {
  const [size, setSize] = useState<WindowsSize>({
    width: typeof window !== "undefined" ? window.innerWidth : 0,
    height: typeof window !== "undefined" ? window.innerHeight : 0,
  });

  useEffect(() => {
    function handleResize() {
      setSize({
        width: window.innerWidth,
        height: window.innerHeight,
      });
    }

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  return size;
};

export default useWindowsSize;
